// extracted by mini-css-extract-plugin
module.exports = {"sticky":"_3kGbg","stickyContent":"_3OS-Z","stickyCompetitionName":"_1RiRV","stickyCompetitionLogo":"_2cQkj","stickyCompetitionLogoImage":"_1U844"};